<template>
  <div>
    <div class="d-flex flex-row justify-space-between">
      <label class="subtitle-1 pb-3 pt-1 mt-4">{{ inputName }} </label>

    </div>
    <small
      class="error--text"
      v-show="affiliateHasError"
    >{{ affiliateErrorMessage }}</small>
    <br>

    <v-card
      class="withdrawal-options mb-3"
      color="white darken-3"
      :key="i"
      v-for="(item, i) in items"
    >
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            md="12"
          >
            <us-states-selector
              v-model="items[i].us_states_ids"
              :isMultiple="true"
              :errorMessages="getStatesError(items[i].us_states_ids, i)"
            />

            <v-textarea
              outlined
              label="URL"
              v-model="items[i].url"
              rows="2"
              :error-messages="replace(head(inputErrors['affiliate_links.' + i + '.url']), 'affiliate_links.' + i + '.url', 'URL')"
            />

          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <b
          @click="removeFAQ(i)"
          class="text-caption font-weight-bold header-btns"
        >remove</b>
      </v-card-actions>
    </v-card>
    <b
      @click="addFAQ"
      class="text-caption font-weight-bold header-btns"
    >Add Item
    </b>
  </div>
</template>

<script>
import UsStatesSelector from '@/components/UsStatesSelector'
import head from 'lodash/head'
import replace from 'lodash/replace'
import isArray from 'lodash/isArray'

export default {
  name: 'TextArrayInput',
  data () {
    return {
      inputErrors: this.errorMessages
    }
  },
  components: {
    UsStatesSelector
  },
  props: {
    items: {
      type: Array,
      default () {
        return []
      }
    },
    inputName: {
      type: String,
      default: 'Items'
    },
    errorMessages: {
      type: [String, Array, Object],
      default () {
        return null
      }
    },
  },
  methods: {
    head,
    replace,
    addFAQ () {
      this.items.push(
        {
          url: null,
          us_states_ids: []
        }
      )
    },
    removeFAQ (i) {
      this.inputErrors = []
      this.items.splice(i, 1)
    },

    getStatesError (states, index) {
      let errorString = null
      states.forEach((value, key) => {
        if (this.inputErrors['affiliate_links.' + index + '.us_states_ids.' + key]) {

          errorString = "The selected states already exist."
        }
      })

      if (this.inputErrors['affiliate_links.' + index + '.us_states_ids']) {

        errorString = "Affiliate state(s) is required."
      }

      return errorString
    }
  },

  computed: {
    affiliateHasError () {
      return this.inputErrors !== null
    },
    affiliateErrorMessage () {
      if (this.inputErrors && this.inputErrors['affiliate_links']) {

        return 'Target State(s) is required.'
      }
      return null
    }
  },

  watch: {
    errorMessages: {
      handler (val) {
        if (val) {
          this.inputErrors = val
        }
      }
    }
  }

}
</script>

<style scoped>
.header-btns {
  color: #df4661;
  cursor: pointer;
}
.withdrawal-options {
  margin-top: 20px;
}

.error-message {
  display: block;
  color: var(--v-error-base);
  font-size: 12px;
  padding-left: 10px;
  padding-top: 4px;
}
</style>
